import JSBI from 'jsbi'

// export const FACTORY_ADDRESS = '0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9' // Hardhat
export const FACTORY_ADDRESS = '0xf83C3416b8B888FBC409CaA3b2bFa1de13764492'   // Testnet
// export const FACTORY_ADDRESS = '0x8bb8aA56642042A8c4dE698E801f2e54Ed5417dc' // MAINNET


// Wrapped Native Coin
export const WETH_ADDRESS = '0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0'         // Hardhat
export const WETH_TESTNET_ADDRESS = '0x80435c19f576a8E07F22279194DBc1125D3a9e74' // Testnet
export const WETH_MAINNET_ADDRESS = '0x110Ac02Ba3384Bc055c13A87766049a74517BedA' // MAINNET

// Get this as a result from test run (should be the same as in DexLibrary contract!)
// Factory contract when deployed, has a public getter for this value
// Before deploying Router contracts - make sure this is the same value in the DexLibrary contract and here below

// export const INIT_CODE_HASH = '0x2606fc7ea7626d55b83f269d5a80da85af2b48b1db22bc0af349c2b3ae40b708'  // Hardhat
export const INIT_CODE_HASH = '0xa17c69a3eb53c839a154093eb238551918063ee79b9eb7015e2fc38addd108c3' // Testnet
// export const INIT_CODE_HASH = '0xa17c69a3eb53c839a154093eb238551918063ee79b9eb7015e2fc38addd108c3' // MAINNET

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  MAINNET = 2786, // MAINNET
  GÖRLI = 31337,  // Hardhat
  ROPSTEN = 89898, // Testnet
  // RINKEBY = 4,
  // KOVAN = 42
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
